<template>
    <div>
      <div>
         <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
        <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
      </div>
      <b-card class="mainCardBG">
        <b-card-text>
          <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>BL List</b-navbar-brand>
          
          <div>
            <h5 class="text-muted justify-content-center">
              <small>{{totalRows}} Entries</small>
            </h5>
          </div>
        </b-navbar>
        <div>
          <div>
            <div>
              <b-button
                v-if="All_BL_List_data.length>0"
                :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                class="pull-right mr-3"
                @click="getReports('BL_LIST', 'Export as Excel')"
                size="sm"
                variant="warning"
                >{{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export as Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
              <!-- <b-button class="pull-right mr-3" v-if="All_BL_List_data.length>0" @click="getReports('BL_LIST')" size="sm"
                variant="warning">Export as Excel</b-button> -->
            </div>
            <b-button variant="outline-dark" :class="visible ? null : 'collapsed'"
            :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4" @click="visible = !visible">
            Filters</b-button>
          </div>
          <b-collapse class="mt-2" v-model="visible" id="collapse-2">
            <b-card>
              <b-row>
                <b-col md="3">
                  <label for="blType">Client</label>
                  <model-list-select
                    :list="$store.getters['common/getAllClientList']"
                    id="clientNamenew"
                    v-model="Filter.clientIdFilter"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select Client Name"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Date :</label>
                  <date-range-picker
                    :opens="openLeft"
                    :always-show-calendars="showCal"
                    v-model="dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    @update="SearchFilter"
                  ></date-range-picker>
                </b-col>
                <b-col md="3">
                  <label>POR</label>
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    @searchchange="
                      getLocationList($event, 'All', 'finalAllPlaceDataPOR')
                    "
                    :list="$store.getters['common/getAllPORList']"
                    v-model="Filter.PORfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Place of Receipt"
                    @update="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>POD</label>
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    @searchchange="
                      getLocationList($event, 'All', 'finalAllPlaceDataPOD')
                    "
                    :list="$store.getters['common/getAllPODList']"
                    v-model="Filter.PODfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Port of Discharge"
                    @update="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Shipping Line</label>
                  <model-list-select
                    :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.shippingLineFilter"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                    @update="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>POL</label>
                  <model-list-select
                    @input="getLocationList($event, 'All', 'PortLoadList')"
                    @searchchange="getLocationList($event, 'All', 'PortLoadList')"
                    :list="$store.getters['common/getAllPOLList']"
                    v-model="Filter.LPlocationId"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POL"
                    @update="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>FPOD</label>
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    :list="$store.getters['common/getAllLocationDetailsFinalList']"
                    v-model="Filter.finalPlaceLocationId"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select FPOD"
                    @update="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Branch</label>
                  <model-list-select
                    class="ml-1"
                    :list="$store.getters['common/getAllBranchList']"
                    id="branchfilter"
                    v-model="Filter.branchfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="All"
                    @input="SearchFilter"
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    "
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Agent Name</label>
                  <model-list-select
                    :list="$store.getters['common/getAllAgentColoaderList']"
                    id="ToFilter"
                    v-model="Filter.ToFilter"
                    option-value="agentName"
                    option-text="agentName"
                    placeholder="All"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Consignee</label>
                  <model-list-select
                    :list="$store.getters['common/getAllConsigneeList']"
                    id="Consignee"
                    v-model="Filter.Consignee"
                    option-value="consignee"
                    option-text="consignee"
                    placeholder="Select Consignee"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Consignor</label>
                  <model-list-select
                    :list="$store.getters['common/getAllConsignorList']"
                    id="Consignor"
                    v-model="Filter.Consignor"
                    option-value="consignorName"
                    option-text="consignorName"
                    placeholder="Select Consignor"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Assignment No.</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    placeholder="Assignment No."
                    id="assignmentNo"
                    name="assignmentNo"
                    v-model="Filter.assignmentNo"
                  ></b-form-input>
                </b-col>
              </b-row>
              <div class="mt-3 row justify-content-center">
                <b-button size="sm" @click="filterSearch" variant="outline-primary">Search
                </b-button>
                <b-button  size="sm" class="ml-2" @click="filterClear"
                  variant="outline-info">clear</b-button>
              </div>
            </b-card>
          </b-collapse>
        </div>
          <div class="table-responsive tableMain mt-2">
            <b-table show-empty stacked="md" :items="All_BL_List_data" :fields="fields" :per-page="perPage"
              :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
              <template slot="ffExportFclId" slot-scope="row0">
                <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
              </template>
              <template slot="bldetails" slot-scope="row1">
                <b class="text-danger" @click="PrintNote(row1.item.uploadBL,row1.item.assignment_number)">{{row1.item.BlNumber}}</b>
              </br>
                <!-- <span>{{row1.item.blDate | moment}}</span> -->
                <span>BL Stage: <b>{{row1.item.blStage}}</b></span></br>
                <span>BL Date: <b>{{row1.item.blDate}}</b></span></br>
                <span>BL Created By: <b>{{row1.item.BlRaisedBy}}</b></span></br>
                <span>BL Created At: <b>{{row1.item.BlCreatedAt}}</b></span>
              </template>

              <template slot="AssignementDetails" slot-scope="row21">
                <b>Assignement Number : {{row21.item.assignment_number}}</b>
                <br>
                <b>Assignement Date : {{row21.item.assigement_date | moment}}</b>
                <br>
                <b>Raised From : {{row21.item.RasiedFrom}}</b>
                <br>
                <b>Rasied By : {{row21.item.username}}</b>  
              </template>

              <template slot="OtherDetails" slot-scope="row3">
                <span><b>POD</b> : {{row3.item.POD}}</span>
                <br>
                <span><b>POL</b> : {{row3.item.POL}}</span>
                <br>
                <span><b>POR</b> : {{row3.item.POR}}</span>
                <br>
                <span><b>FPOD</b> : {{row3.item.FPOD}}</span>
                <br>
              </template>
              <template slot="clientName" slot-scope="row4">
                <span>Client Name : <b>{{row4.item.clientName}}</b></span>
                <br>
                <span>Shipper Name : <b>{{row4.item.ShippingLine}}</b></span>
              </template>
              <template slot="consignor" slot-scope="row5">
                <span>{{row5.item.consignor}}</span>
              </template>
              <template slot="consignee" slot-scope="row6">
                <span>{{row6.item.consignee}}</span>
              </template>
              <template slot="agentdetails" slot-scope="row7">
                <span>{{row7.item.agentName}}</span>
              </template>
              <template slot="notify" slot-scope="row8">
                <span>{{row8.item.notify}}</span>
              </template>
              <template slot="description" slot-scope="row9">
                <span>{{row9.item.description}}</span>
              </template>
              <template slot="UsNonUs" slot-scope="row10">
                <span>{{row10.item.location}}</span>
              </template>
            </b-table>
          </div>
          <div>
            <b-pagination limit="5" align="center" v-model="currentPage" :per-page="perPage" :total-rows="totalRows"
              @change="onPageChange($event)"></b-pagination>
          </div>
        </b-card-text>
      </b-card>
    </div>
  </template>
  
  
  <script>
    import CommonService from "../../services/CommonService.js";
    import axios from "axios";
    import moment from "moment";
    import { ModelListSelect } from "vue-search-select";
    // import Loading from "vue-loading-overlay";
    import CustomLoader from "../common/customLoader.vue";
    import DateRangePicker from "vue2-daterange-picker";
    import "vue-loading-overlay/dist/vue-loading.css";
    import DatePicker from "vue2-datepicker";
    import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
    import { DateFormat, selectDateFormat} from "../../helper/filters";
    import { globalPermissionStatus } from "../../helper/collection";
    import {
      GlobalGetLocation
    } from "../../helper/collection";
  
    export default {
      beforeMount() {
        if (globalPermissionStatus("Sea Freight")) {
          this.$store.dispatch("setCurrentRoute", "/Freight/bl-list");
          this.$store.dispatch("common/setAllAgentColoaderList");
          this.$store.dispatch(
            "common/setAllBranchList",
            JSON.stringify({
              filter: "BranchList",
              active: "all"
            })
          );
          this.$store.dispatch(
            "common/setAllConsigneeList",
            JSON.stringify({
              itemCode: "ConsigneeList"
            })
          );
          this.$store.dispatch(
            "common/setAllConsignorList",
            JSON.stringify({
              itemCode: "ConsignorList"
            })
          );
          this.$store.dispatch(
            "common/setAllClientList",
            JSON.stringify({
              itemCode: "ClientList"
            })
          );
          this.$store.dispatch(
            "common/setAllPORList",
            JSON.stringify({
              itemCode: "PORList"
            })
          );
          this.$store.dispatch(
            "common/setAllPODList",
            JSON.stringify({
              itemCode: "PODList",
               type:'Normal',
        Territory:'',
              
            })
          );
          this.$store.dispatch(
            "common/setAllPOLList",
            JSON.stringify({
              itemCode: "POLList"
            })
          );
          this.$store.dispatch(
            "common/setAllShippingLineList",
            JSON.stringify({
              itemCode: "ShippingLineList"
            })
          );
          this.$store.dispatch(
            "common/setAllLocationDetailsFinalList",
            JSON.stringify({
              itemCode: "LocationDetailsFinalList"
            })
          );
          this.$sessionsStorage.set(
            "PermissionStatus",
            globalPermissionStatus("QuotationAssignment")
          )
        this.getBLList();
        } else {
          this.$router.push({
            path: "/dashboard"
          });
        }
      },
      data() {
        return {
          topcommodity: [],
          All_BL_List_data: [],
          seriesExDesti: [
            {
              name: "No. of Containers",
              data: [],
            },
          ],
          chartOptionsExDesti: {
            chart: {
              height: 350,
              type: "bar",
            },
            plotOptions: {
              bar: {
                columnWidth: "50%",
                endingShape: "rounded",
              },
            },
            dataLabels: {
              enabled: true,
            },
            stroke: {
              width: 2,
            },
  
            grid: {
              row: {
                colors: ["#fff", "#f2f2f2"],
              },
            },
            xaxis: {
              labels: {
                rotate: -45,
              },
              categories: [],
              tickPlacement: "on",
            },
            yaxis: {
              title: {
                text: "No. of Containers",
              },
            },
            fill: {
              type: "",
              gradient: {
                shade: "dark",
                type: "horizontal",
                shadeIntensity: 1,
                gradientToColors: undefined,
                inverseColors: true,
                opacityFrom: 0.85,
                opacityTo: 0.85,
                stops: [50, 0, 100],
              },
            },
          },
          seriesShip: [
            {
              name: "No. of Containers Shipped",
              data: [],
            },
          ],
          chartOptionsShip: {
            chart: {
              height: 350,
              type: "bar",
            },
            plotOptions: {
              bar: {
                columnWidth: "50%",
                endingShape: "rounded",
              },
            },
            dataLabels: {
              enabled: true,
            },
            stroke: {
              width: 2,
            },
  
            grid: {
              row: {
                colors: ["#fff", "#f2f2f2"],
              },
            },
            xaxis: {
              labels: {
                rotate: -45,
              },
              categories: [],
              tickPlacement: "on",
            },
            yaxis: {
              title: {
                text: "No. of Containers Shipped",
              },
            },
            fill: {
              type: "gradient",
              gradient: {
                shade: "light",
                type: "horizontal",
                shadeIntensity: 0.25,
                gradientToColors: undefined,
                inverseColors: true,
                opacityFrom: 0.85,
                opacityTo: 0.85,
                stops: [50, 0, 100],
              },
            },
          },
          seriesRefuel: [
            {
              name: "No. of Containers Executed",
              data: [],
            },
          ],
          chartOptionsRefuel: {
            chart: {
              height: 350,
              type: "bar",
            },
            plotOptions: {
              bar: {
                columnWidth: "50%",
                endingShape: "rounded",
              },
            },
            dataLabels: {
              enabled: true,
            },
            stroke: {
              width: 2,
            },
  
            grid: {
              row: {
                colors: ["#fff", "#f2f2f2"],
              },
            },
            xaxis: {
              labels: {
                rotate: -45,
              },
              categories: [],
              tickPlacement: "on",
            },
            yaxis: {
              title: {
                text: "No. of Containers Executed",
              },
            },
            fill: {
              type: "gradient",
              gradient: {
                shade: "light",
                type: "horizontal",
                shadeIntensity: 0.25,
                gradientToColors: undefined,
                inverseColors: true,
                opacityFrom: 0.85,
                opacityTo: 0.85,
                stops: [50, 0, 100],
              },
            },
          },
          fieldsV: [
            {
              key: "vehicleTruckId",
              label: "Sr No.",
              sortable: true,
              sortDirection: "desc"
            },
            {
              key: "regdNo",
              label: "Vehicle No.",
              sortable: true,
              sortDirection: "desc"
            },
  
            {
              key: "noOfTripscount",
              label: " No. Of Trips",
              sortable: true,
              sortDirection: "desc"
            },
  
  
  
            {
              key: "sumDieselUsed",
              label: " Diesel Consumed (Ltr's)",
              sortable: true,
              sortDirection: "desc"
            }
  
          ],
          totalVehicleCount: "",
          availVehicleCount: "",
          bookVehicleCount: "",
          currentPageV: 1,
          perPageV: 10,
          totalRowsV: "",
          pageOptionsV: [5, 10, 15],
          sortByV: null,
          sortDescV: false,
          sortDirectionV: "desc",
          ExcelBtnName: 'Export as Excel',
          filterV: null,
          modalInfo: { title: "", content: "" },
          clientMaster: [],

          Filter: {
            PODfilter: "",
            PORfilter: "",
            clientIdFilter: "",
            shippingLineFilter: "",
            LPlocationId: "",
            branchfilter: "",
            finalPlaceLocationId: "",
            ToFilter: "",
            Consignee: "",
            Consignor: "",
            agntColoaderId: "",
            assignmentNo: "",
          },

          clientTypeList: [
            {
              type: "Client",
              val: "1"
            },
            {
              type: "Lead",
              val: "2"
            },
            {
              type: "Overseas Agent",
              val: "3"
            },
            {
              type: "Consignee",
              val: "4",
            },
          ],
          topTPTClientRevenue: [],
          vehicleReports: [],
          transportTypeFilter: "",
          transportTypeName: [
            {
              transportTypeVal: "Export",
              transportTypeText: "Export"
            },
            {
              transportTypeVal: "Import",
              transportTypeText: "Import"
            }
          ],
          reload: true,
  
          visible: false,
          selectDateFormat,
          openLeft: "right",
          showCal: false,
          startDate: "2017-09-05",
          endDate: "2017-09-15",
          dateRange: {
            startDate: "",
            endDate: ""
          },
          dateSearch: {
            fromDate: "",
            toDate: ""
          },
          totalRows: "",
          currentPage: 1,
          perPage: 10,
          pageOptions: [20, 50, 100],
          sortBy: null,
          sortDesc: false,
          sortDirection: "asc",
          filter: null,
          docURL: URL_BASE_DOC,
          fields: [
            {
              key: "ffExportFclId",
              mainkey: "ffExportFclId",
              label: "Sr No.",
              sortable: true,
              sortDirection: "ASC"
            },
            {
              key: "bldetails",
              mainkey: "bldetails",
              label: "BL Details",
              sortable: true,
              width: "100px",
              sortDirection: "ASC"
              //  table: "B."
            },
            {
              key: "AssignementDetails",
              mainkey: "AssignementDetails",
              label: "Assignment Details",
              sortable: true,
              sortDirection: "ASC"
              // table: "P."
            },
  
  
  
            {
              key: "OtherDetails",
              mainkey: "OtherDetails",
              label: " Other Details",
              sortable: true,
              sortDirection: "ASC"
              //  table: "B."
            },
            // {
            //   key: "LoadPort",
            //   mainkey: "LoadPort",
            //   label: "Required Container",
            //   sortable: true,
            //   sortDirection: "ASC"
            //   //   table: "D."
            // },
  
  
            {
                key: "clientName",
                mainkey: "clientName",
                label: "Client / Shipper Name",
                width: "500px",
                sortable: true,
                sortDirection: "ASC"
                //   table: "D."
            },
            {
              key: "consignor",
              mainkey: "consignor",
              label: "Consignor",
              sortable: true,
              sortDirection: "ASC"
            },
            {
              key: "consignee",
              mainkey: "consignee",
              label: "Consignee",
              sortable: true,
              sortDirection: "ASC"
            },
            {
              key: "agentdetails",
              mainkey: "agentdetails",
              label: "Agent Details",
              sortable: true,
              sortDirection: "ASC"
            },
            {
              key: "notify",
              mainkey: "notify",
              label: "Notify",
              sortable: true,
              sortDirection: "ASC"
            },
            {
              key: "description",
              mainkey: "description",
              label: "Description",
              sortable: true,
              sortDirection: "ASC"
            },
            {
              key: "UsNonUs",
              mainkey: "UsNonUs",
              label: "US/NonUS",
              sortable: true,
              sortDirection: "ASC"
            },
  
          ],
          NoOfAssignment: "",
          isLoading: false,
          showGraph: false,
          viewAssignment1: [],
          getCLientData: [],
        };
      },
  
      filters: {
        moment(date) {
          return DateFormat(date)
        }
      },
  
      mounted() { },
      beforeDestroy() { },
      destroyed() { },
      components: {
        ModelListSelect,
        // Loading,
        CustomLoader,
        DateRangePicker
      },
      computed: {
        clientList() {
          return this.getCLientData;
        },
        sortOptions() {
          // Create an options list from our fields
          return this.fieldsV
            .filter(f => f.sortable)
            .map(f => {
              return { text: f.label, value: f.key };
            });
        }
      },
  
      methods: {
        onFilteredV(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRowsV = filteredItems.length;
          this.currentPageV = 1;
        },
        SearchFilter(event) {
          clearTimeout(this.debounce);
          this.debounce = setTimeout(() => {
            this.getBLList();
          }, 1000);
        },
        filterSearch() {
          this.reload = false;
          this.getBLList();
        },
        getLocationList(event, type, vmodelArray) {
          let vehicle_drive = {
            value: event,
            type: type
          };
          let self = this;

          if (event != "") {
            GlobalGetLocation(vehicle_drive, function(error, result) {
              if (error) {
              } else if (result) {
                if (result.length > 0) {
                  self[vmodelArray] = result;
                }
              }
            });
          }
        },
        PrintNote(uploadCreditDebit, assign_job) {
          let key =
            "ASSIGNMENT_UPLOADS/" +
            assign_job.replaceAll("/", "_") +
            "/" +
            uploadCreditDebit;
          this.openSignedDocument(key);
        },
        
        getReports(id, btnName) {
          let agntColoaderId = "";
          if(this.Filter.ToFilter){
            let agentArr = this.$store.getters['common/getAllAgentColoaderList'].filter((x)=>{
              if(this.Filter.ToFilter == x.agentName){
                return x;
              }
            });
            if(agentArr.length>0){
              this.Filter.agntColoaderId = agentArr[0].agntColoaderId;
            }
          }
          let payload = {
            excelId: id,
            Filter: this.Filter,
            dateRange: this.dateRange,
          };
          this.ExcelBtnName = "Downloading Please Wait...";
          this.$store.dispatch(
            "common/setAllPendingReverseTallyExcel",
            JSON.stringify(payload)
          );
          let ExcelName = "";
          if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
            this.ExcelBtnName = btnName;
            ExcelName = this.$store.getters[
              "common/getAllPendingReverseTallyExcel"
            ];
          }
        },
        filterClear() {
          (this.Filter = {
            PODfilter: "",
            PORfilter: "",
            clientIdFilter: "",
            shippingLineFilter: "",
            LPlocationId: "",
            branchfilter: "",
            finalPlaceLocationId: "",
            ToFilter: "",
            Consignee: "",
            Consignor: "",
            assignmentNo: "",
          }),
          (this.dateSearch.fromDate = "");
          this.dateSearch.toDate = "";
          this.getBLList();
        },
        onPageChange: function (event) {
          let CURRENT = 0;
          if (event == "1") {
            CURRENT = 0;
          } else {
            CURRENT = event * this.perPage - this.perPage;
          }
  
          this.getBLList();
  
          // let totalRows = 1064 / this.perPage;
          // if(this.totalRow )
        },
        viewVBookingPage(
          clientId
        ) {
          this.$sessionsStorage.set("clientId", clientId);
         
  
          this.$router.push({
            path: "/vehicle/vehicleBooking"
          });
        },
        goToTrack(AId) {
          this.$sessionsStorage.set("storeAssignId", AId);
          this.$sessionsStorage.set("backToDetailPage", "22");
          this.$router.push({
            path: "/vehicleQuotation/tranportMailDetails"
          });
        },
        goToMain() {
          this.$router.push({
            path: "/sales/salesBooking"
          });
        },
        doLoading() {
          this.isLoading = true;
        },
        doLoadingClose() {
          this.isLoading = true;
  
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        },
  
        JqueryFun() {
          return $(function () {
            return $("#viewVehicleBooking21212").DataTable();
          });
        },
        getBLList() {
          this.isLoading = true;
          let agntColoaderId = "";
          if(this.Filter.ToFilter){
            let agentArr = this.$store.getters['common/getAllAgentColoaderList'].filter((x)=>{
              if(this.Filter.ToFilter == x.agentName){
                return x;
              }
            });
            if(agentArr.length>0){
              this.Filter.agntColoaderId = agentArr[0].agntColoaderId;
            }
          }
          let payload = {
              excelId: "Master_BL_List",
              Filter: this.Filter,
              dateRange: this.dateRange,
          };
          // JSON.stringify();
          // await
          CommonService.getAllBL_List(payload)
          .then(response => {
              const { data, status, statusText } = response;
              console.log("Shreshth Gahlot => ", status);
              console.log("Shreshth Gahlot => ", data);
              if (status == 200 && data) {
                  this.All_BL_List_data = data.All_BL_List_data;
                  this.totalRows = data.All_BL_List_data.length;
                  console.log(" All_BL_List Count response=>", data);
              } else {
                  this.All_BL_List_data = [];
              }
              this.isLoading = false;
          })
          .catch(error => {
              console.log("Catch on All_BL_List Error: ", error);
          });
        },
      }
    };
  </script>
  <style>
  .md-theme-default.md-tabs>.md-tabs-navigation {
      background-color: #ffffff;
  }
  .md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header{
    color: #6e6b79;
  }
  .md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header.md-active, .md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header:focus {
    color: #6e6b79;
  }
  .md-theme-default.md-tabs > .md-tabs-navigation .md-tab-indicator {
    background-color: #002b48; 
    height: 4px;
    border-radius: 10px;
  }
  .md-whiteframe {
    background: #fff;
    box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
    -webkit-box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
    border-radius: 0.423rem
  }
  </style>


// WEBPACK FOOTER //
// bl-list.vue?6f8475c5